import {
  UPDATE_CITIES_LIST,
  UPDATE_CITIES_LOADING,
} from "../../store/actionTypes";

const initialState = {
  total: 0,
  pageNo: 1,
  limit: 10,
  totalPage: 0,
  searchKey: "",
  citiesList: [],
  sortOrder:1,
  sortBy:'cityName',
  isLoading: false,
};

/**
 *
 * @param {initial state of reducer} state
 * @param { perfoam actions } action
 * @returns update state of reducer
 */
const CityReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CITIES_LIST: {
      return { ...state, ...action.payload };
    }
    case UPDATE_CITIES_LOADING: {
      return { ...state, ...{ isLoading: !state.isLoading } };
    }
    default:
      return state;
  }
};
export default CityReducer;
